var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._g(_vm._b({staticClass:"jz-text-description",class:[_vm.data.staticClass, _vm.data.class, { 'is-inline': _vm.props.inline }]},'div',_vm.data.attrs,false),_vm.listeners),[(_vm.props.text)?[_vm._v(_vm._s(_vm.props.text))]:_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }